var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPackageIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.723,
    height: 22.85,
    viewBox: "0 0 20.723 22.85",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "package",
    transform: "translate(-1.65 -0.652)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union_194",
    "data-name": "Union 194",
    d: "M125.5-8196.261a2.693,2.693,0,0,1-.99-.337l-7.157-4.09a2.721,2.721,0,0,1-1.355-2.339v-8.182a2.7,2.7,0,0,1,.26-1.149.674.674,0,0,1,.076-.241.641.641,0,0,1,.207-.229,2.69,2.69,0,0,1,.81-.72l3.436-1.964a.653.653,0,0,1,.364-.208l3.36-1.92a2.7,2.7,0,0,1,1.349-.363,2.726,2.726,0,0,1,1.353.361l7.155,4.09a2.7,2.7,0,0,1,.812.724.649.649,0,0,1,.19.2.658.658,0,0,1,.094.273,2.7,2.7,0,0,1,.257,1.144v8.184a2.722,2.722,0,0,1-1.351,2.339l-7.161,4.092a2.729,2.729,0,0,1-.987.335.656.656,0,0,1-.362.108A.654.654,0,0,1,125.5-8196.261Zm-8.185-14.947v8.182a1.4,1.4,0,0,0,.693,1.2l7.159,4.09.039.022v-9.012l-7.888-4.562C117.311-8211.263,117.31-8211.235,117.31-8211.208Zm9.2,13.49.037-.021,7.161-4.092a1.393,1.393,0,0,0,.691-1.2v-8.18c0-.027,0-.055,0-.082l-7.886,4.563Zm-.658-10.149,3.3-1.907-7.85-4.521-3.3,1.887Zm4.614-2.668,3.24-1.873h0l-7.157-4.09a1.392,1.392,0,0,0-.7-.187,1.386,1.386,0,0,0-.693.186l-2.536,1.449Z",
    transform: "translate(-113.844 8219.154)",
    fill: "#212121",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPackageIcon);
export default __webpack_public_path__ + "static/media/package_icon.5a0bee0a1486865f00d58c05246cfbd9.svg";
export { ForwardRef as ReactComponent };